'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import WidgetIcon from 'ContentComponents/cmv2/WidgetIcon';
import withFileManagerDrawer from 'DesignEditorsUI/components/shared/hoc/withFileManagerDrawer';
import IconDrawer from 'ContentComponents/cmv2/iconPicker/IconDrawer';
import { ICON_SETS } from 'ContentUtils/constants/IconSets';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.icon.${key}`;

const IconSelect = ({
  customWidgetIcon: icon,
  FileManager,
  onFileManagerOpen,
  onResetToDefault,
  onIconSelect
}) => {
  const [iconDrawerIsOpen, setIconDrawerOpenState] = useState(false);

  const toggleIconDrawerState = () => setIconDrawerOpenState(!iconDrawerIsOpen);

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('iconSelect.label')
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "column",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "icon-upload-button",
          onClick: onFileManagerOpen,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(WidgetIcon, {
            size: "xxl",
            icon: icon
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(IconDrawer, {
          icons: [],
          iconSet: ICON_SETS['fontawesome-5.14.0'],
          isOpen: iconDrawerIsOpen,
          onClose: toggleIconDrawerState,
          onIconSelect: iconData => {
            toggleIconDrawerState();
            onIconSelect(iconData);
          },
          selectedIcons: [],
          totalIcons: 100
        }), /*#__PURE__*/_jsx(UIButton, {
          className: "m-bottom-4",
          onClick: toggleIconDrawerState,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('iconSelect.browseIcons')
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "m-bottom-4",
          onClick: onFileManagerOpen,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('iconSelect.uploadIcon')
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: onResetToDefault,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('iconSelect.resetToDefault')
          })
        })
      })]
    }), FileManager]
  });
};

IconSelect.propTypes = {
  customWidgetIcon: PropTypes.string,
  onResetToDefault: PropTypes.func.isRequired,
  FileManager: PropTypes.node,
  onFileManagerOpen: PropTypes.func.isRequired,
  onIconSelect: PropTypes.func
};
export default withFileManagerDrawer(IconSelect);